@if (state.creatingReviewItemError) {
  <div class="absolute left-0 top-0 z-[1000] flex h-full w-full flex-col items-center justify-center bg-white">
    @if (state.creatingReviewItemError === CreatingReviewItemBackendError.NoCandidateQuestions) {
      <div>No reference questions left for this mode.</div>
    } @else if (state.creatingReviewItemError === CreatingReviewItemBackendError.UserHasNoPermission) {
      <div class="text-red-500">You do not have permission to review this item</div>
    } @else {
      <div class="text-red-500">{{ state.creatingReviewItemError }}</div>
    }
  </div>
} @else if (!state.mode) {
  <div class="absolute left-0 top-0 z-[1000] flex h-full w-full flex-col items-center justify-center bg-white">
    <div>Invalid review mode</div>
  </div>
} @else if (!state.question || state.creatingReviewItem) {
  <div class="absolute left-0 top-0 z-[1000] flex h-full w-full flex-col items-center justify-center bg-white">
    <dojo-loader [centered]="true" />
  </div>
}

<as-split [direction]="'horizontal'" unit="pixel" class="h-full" [gutterSize]="1" [useTransition]="true">
  <as-split-area class="flex h-full flex-col" [size]="'*'" [minSize]="200">
    <div class="z-3 sticky top-0">
      <dojo-question-validation-header>To review & fix</dojo-question-validation-header>

      <div class="bg-neutral-0 flex items-center gap-1 border-b border-neutral-200 py-1.5 pl-3 pr-4">
        @if (state.question) {
          <div class="text-xs text-neutral-400">Question ID: {{ state.question.id }}</div>
        }
        <div class="ml-auto flex items-center gap-1">
          @if (state.referenceQuestion && state.editingOptions?.showReferenceQuestion) {
            <dojo-button
              [size]="'xs'"
              [fill]="'outline'"
              [customColor]="'indigo'"
              dojoReferenceQuestionPopupTrigger
              [referenceQuestion]="state.referenceQuestion"
              [markCalculationMethod]="state.markCalculationMethod"
            >
              Ref. question
            </dojo-button>
          }
          @if (state.anyEditingAllowed) {
            <dojo-button
              [size]="'xs'"
              [fill]="'outline'"
              [customColor]="'sky'"
              [disabled]="!state.canUndo"
              (click)="undo()"
              [matTooltip]="'Undo'"
            >
              <dojo-icon icon="undo" />
            </dojo-button>
            <dojo-button
              [size]="'xs'"
              [fill]="'outline'"
              [customColor]="'sky'"
              [disabled]="!state.canRedo"
              (click)="redo()"
              [matTooltip]="'Redo'"
            >
              <dojo-icon icon="redo" />
            </dojo-button>
          }
          @if (state.isAdmin || state.allowJsonEditor) {
            <dojo-button [size]="'xs'" [fill]="'outline'" [customColor]="'sky'" dojoJsonEditorTrigger>
              JSON
            </dojo-button>
          }
        </div>

        @if (state.editingOptions?.allowQuestionStructureEditing) {
          <dojo-new-question-item-button class="ml-2" />
        }
      </div>
    </div>
    <div class="scrollbar-gutter-stable overflow-y-auto pl-2">
      <dojo-question-items-editor
        [calculatorAllowed]="state.calculatorAllowed"
        [markCalculationMethod]="state.markCalculationMethod"
      />
    </div>
  </as-split-area>

  <!-- Sidebar -->
  <as-split-area class="flex h-full flex-col !overflow-y-hidden" [minSize]="280" [maxSize]="600" [size]="400">
    @if (state.question && state.mode) {
      <dojo-derivative-question-sidebar
        [reviewType]="state.mode"
        [question]="state.question"
        [hidden]="state.activeItem || state.activeSubItem"
        [isSubmitting]="state.isSendingFeedback"
        [calculatorAllowed]="state.calculatorAllowed"
        (formStateChange)="reviewFormState.set($event)"
        class="flex h-full flex-col"
      />
      @if (state.activeItem || state.activeSubItem) {
        <dojo-question-active-item-editor />
      }
    } @else {
      <div class="flex h-full flex-col items-center justify-center">
        <dojo-loader />
      </div>
    }
  </as-split-area>
</as-split>

<!-- Footer -->
<div class="sticky bottom-0 flex justify-between gap-2 border-t border-neutral-200 bg-neutral-50 p-2 px-4">
  @if (state.isSkippable) {
    <dojo-button
      [disabled]="!state.question || state.isSaving"
      [pending]="isSkipping()"
      [fill]="'outline'"
      (click)="openSkipQuestionDialog()"
    >
      Skip question
    </dojo-button>
  } @else {
    <!-- Empty space to push the next button to the right -->
    <div></div>
  }
  <div class="flex items-center gap-2">
    <!-- TODO - Braintrust for derivative questions -->
    <!-- @if (state.canStoreInBraintrust && state.isAdmin) {
      <mat-slide-toggle
        class="small mr-2"
        color="primary"
        [checked]="storeInBraintrust()"
        (change)="storeInBraintrust.set(!storeInBraintrust())"
      >
        Store in Braintrust
      </mat-slide-toggle>
      @if (storeInBraintrust()) {
        <input
          class="text-md border-neutral-200 bg-white p-[5px]"
          style="border-radius: 0.5rem"
          type="text"
          [value]="brainTrustDataset()"
          (input)="onBrainTrustDatasetChange($event)"
        />
      }
    } -->
    @if (state.formState) {
      <dojo-button
        [customColor]="
          state.formState.canSubmit && state.formState.submitText === SubmitButtonText.ApproveContinue
            ? 'green'
            : state.formState.canSubmit
              ? 'red'
              : undefined
        "
        (click)="saveAndContinue()"
        [disabled]="!state.formState.canSubmit"
        [pending]="state.isSaving || state.isSendingFeedback"
      >
        {{ state.formState.submitText }}
      </dojo-button>
    } @else {
      <!-- When the form is not visible, show the disabled button to not break the layout -->
      <dojo-button [disabled]="true" (click)="saveAndContinue()">{{ SubmitButtonText.ApproveContinue }}</dojo-button>
    }
  </div>
</div>
